import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
import Link from "next/link";
const Card = /*#__PURE__*/styled("article")({
  name: "Card",
  class: "c1lv71e1"
});
const Row = /*#__PURE__*/styled("div")({
  name: "Row",
  class: "rf18ss"
});

const ContentCard = ({
  coverImage,
  title,
  genre,
  contentTitle,
  acceptableNumberOfPeople,
  approximateTimeOfUse,
  id,
  name
}) => {
  return <Card>
      <Link href={`/facilities/${id}`}>
        <a>
          <img src={coverImage} height={261} alt={title} />
        </a>
      </Link>
      <p className="category">{genre}</p>
      <Link href={`/facilities/${id}`}>
        <a>
          <h2>{contentTitle}</h2>
        </a>
      </Link>
      <p className="name">{name}</p>
      {
      /* <p className="prefecture">{prefecture}</p> */
    }
      <div className="tags-list">
        {approximateTimeOfUse && <Row>
            <div className="tag">
              <p>所要時間</p>
              <div />
              <p>{approximateTimeOfUse}</p>
            </div>
          </Row>}
        {acceptableNumberOfPeople && <Row>
            <div className="tag">
              <p>受入可能人数</p>
              <div />
              <p>{acceptableNumberOfPeople}</p>
            </div>
          </Row>}
      </div>
    </Card>;
};

export { ContentCard };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");